import $ from "jquery";

const thankYouPage = $('.js-form').attr('data-page');

document.querySelector('.form__main form').addEventListener('wpcf7mailsent', function(event) {
    location = thankYouPage;
}, false);